import { useCallback } from 'react';
import { useTranslation, withTranslation, WithTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { useAppSelector } from '@redux/store';
import { GridBreak } from '@components/Utils';
import { Button, Grid, Typography } from '@ts/storybook';

interface ForbiddenProps extends WithTranslation {
  date?: string;
  url?: string;
  action?: string;
  details?: string;
}

const Error403 = (props: ForbiddenProps) => {
  const location = useLocation();
  const { t } = useTranslation();
  const aclList = useAppSelector(state => state.global.aclList);
  const navigate = useNavigate();

  const handleClickGoBack = useCallback(() => {
    navigate(-1);
  }, []);

  if (Object.keys(aclList).length === 0) return;

  return (
    <Grid container spacing={2} justifyContent="center">
      <Grid size={6}>
        <div style={{ paddingLeft: '10px' }}>
          <div>
            <div style={{ fontSize: '52px' }}>403</div>
            <br />
            <div style={{ fontSize: '22px' }}>{t('Your role does not allow you to perform this action')}</div>
            <br />
            <div style={{ fontSize: '22px' }}>
              <Typography variant="subtitle1" text={['Timestamp_semi', props.date || Date()]} />
              <Typography variant="subtitle1">URL: {props.url || location.pathname} </Typography>
              {/* <Typography variant="subtitle1" text={['Action_semi', props.action || routeAction]} /> */}
              {props.details && <Typography variant="subtitle1" text={['Details:', props.details]} />}
            </div>
          </div>
        </div>
      </Grid>
      <GridBreak />
      <Grid size={6}>
        <Button onClick={handleClickGoBack} label="Go back" />
      </Grid>
    </Grid>
  );
};

export default withTranslation()(Error403);
